
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Sedancabsbookinginpune() {



    const cardData =
    {
        keyword: ' Sedan Cabs Booking in Pune',
        heading: 'Prince Cabs: Sedan Cabs Booking in Pune',
        headingDescription: 'Prince Cabs offers convenient Sedan Cabs Booking in Pune, ideal for local rides, airport transfers, corporate travel, and outstation trips. Our fleet of well-maintained sedan cars like Swift Dzire, Etios, and other premium models ensures a safe, comfortable, and budget-friendly journey. With professional chauffeurs, transparent pricing, and easy booking options, we make every ride smooth and hassle-free. Choose Prince Cabs’ trusted sedan cab booking service in Pune for reliability, affordability, and complete comfort.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was once the grand seat of the Peshwas of the Maratha Empire. Though much of it was destroyed in a fire, its mighty gates, expansive courtyards, and stone walls still narrate tales of Maratha valor. The evening light-and-sound show brings history to life with stories of bravery and intrigue. Visitors love exploring its gardens and ruins. Shaniwar Wada is Pune’s most iconic heritage fort and a must-visit landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is an architectural marvel with immense historical significance. During the Quit India Movement, Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here. Today, it houses a museum displaying Gandhi’s personal belongings and photographs. The sprawling gardens provide a peaceful retreat. Recognized as a national monument, it symbolizes sacrifice and patriotism. It is among Pune’s most revered landmarks."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 30 km from Pune, is known for the historic 1670 Battle of Sinhagad. The fort’s ruins, bastions, and memorials tell stories of Maratha bravery and sacrifice. Trekkers enjoy the scenic climb, especially during monsoon when the hills are lush and misty. From the summit, panoramic views of the Sahyadris are breathtaking. Local food stalls serving pithla-bhakri add to the rustic charm. Sinhagad is both a historical and adventure hotspot."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most famous spiritual landmark dedicated to Lord Ganesha. The idol is adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of cultural festivities. It is also renowned for charitable and community services. Its central location makes it easily accessible. Dagdusheth is both a spiritual and cultural icon of Pune."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill, one of Pune’s highest points, offers panoramic views of the city skyline. At the summit lies the Parvati Temple complex dedicated to Lord Shiva and Goddess Parvati. The climb of over 100 steps is spiritually rewarding and historically significant. The Peshwa Museum nearby showcases artifacts from Maratha times. Sunrises and sunsets from here are especially mesmerizing. Parvati Hill blends devotion, history, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, dating back to the 8th century, is a rock-cut shrine dedicated to Lord Shiva. Its massive stone pillars, sanctum, and stone-carved Nandi reflect Rashtrakuta-era architecture. Despite being in the city center, the temple offers a tranquil space for meditation. Tourists admire its simplicity and historical charm. It is a hidden gem on Pune’s heritage map. Pataleshwar is perfect for history and spirituality seekers."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its diverse collection includes musical instruments, sculptures, paintings, and everyday objects. A highlight is the recreated Mastani Mahal, showcasing Maratha heritage. The museum reflects India’s cultural richness and artistry. It is fascinating for historians, art lovers, and families. This museum is one of Pune’s most unique attractions."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "The Osho International Meditation Resort in Koregaon Park is a world-renowned spiritual retreat. Visitors from across the globe come here for meditation, wellness programs, and yoga. Surrounded by serene gardens and modern architecture, it offers a peaceful escape from city life. The ashram promotes holistic well-being and inner transformation. Its vibrant international community adds cosmopolitan charm. Osho Ashram blends spirituality with lifestyle."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity in Viman Nagar is Pune’s largest shopping and entertainment hub. It houses global and Indian brands, multiplex cinemas, gaming zones, and gourmet restaurants. Seasonal festivals and events make it vibrant and lively. Families enjoy shopping, dining, and leisure under one roof. It reflects the modern side of Pune. Phoenix Marketcity is the city’s ultimate lifestyle destination."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, about 20 km from Pune, is a favorite weekend picnic spot. It supplies water to the city and is surrounded by green hills. Families enjoy boating, roadside food, and evening walks near the reservoir. Monsoon transforms the landscape into a lush paradise. The cool breeze makes evenings refreshing. Khadakwasla is a peaceful getaway close to Pune."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake, formed by the Mulshi Dam, is a serene outstation escape near Pune. Surrounded by Sahyadri hills and dense forests, it is ideal for camping, boating, and photography. Monsoon enhances its charm with waterfalls and misty valleys. Eco-resorts around the lake offer a perfect retreat. It is popular among couples, families, and trekkers. Mulshi balances adventure with tranquility."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Chaturshringi Temple, situated on Senapati Bapat Road, is one of Pune’s oldest shrines dedicated to Goddess Chaturshringi. Devotees climb over 100 steps to reach the sanctum. The temple is especially grand during Navratri celebrations, attracting thousands of pilgrims. Its hilltop location offers beautiful city views. The temple symbolizes faith and devotion. It is both a spiritual and cultural landmark of Pune."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "The National War Memorial in Pune honors soldiers who laid down their lives post-independence. The site showcases tanks, weapons, and war memorabilia. The museum narrates stories of India’s military history. The evening flag retreat ceremony is deeply moving. Families and students visit to instill pride and patriotism. It is a place of respect and remembrance for the armed forces."
  },
  {
    "title": "Empress Garden",
    "description": "Spread across 39 acres, Empress Garden is a lush botanical park managed by the Agri-Horticultural Society. It houses rare plants, shaded pathways, and vibrant flower nurseries. Families enjoy picnics and leisure time in its green setting. The annual flower show is a highlight for garden lovers. The garden also carries colonial-era history. Empress Garden is a refreshing oasis in Pune."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi, the highest hill in Pune, is a popular destination for trekkers, joggers, and nature lovers. The hilltop offers sweeping views of the city and surrounding areas. It is rich in biodiversity, attracting birdwatchers and fitness enthusiasts. Early mornings are peaceful with fresh air and greenery. Sunrises and sunsets from here are mesmerizing. Vetal Hill is Pune’s natural retreat and green lung."
  }
],

"services": [
  {
    "name": "Sedan Car Hire Pune",
    "description": "Hire a comfortable and well-maintained sedan car in Pune for your daily travel, business meetings, or weekend outings. Our sedan car hire services offer a balance of affordability, style, and reliability—making them ideal for both solo travelers and small groups. Choose from top models like Dzire and Etios, with options for hourly, daily, or long-term rentals. Whether you need the car for city travel or intercity commutes, our professional drivers and clean vehicles ensure a smooth and pleasant experience every time."
  },
  {
    "name": "Sedan Cabs for Local Travel Pune",
    "description": "Book sedan cabs in Pune for comfortable and affordable local travel. Ideal for city commutes, shopping trips, doctor visits, and quick errands, our sedan services ensure clean, air-conditioned vehicles and courteous drivers. With quick pickup times, flexible booking slots, and cost-effective fares, you get the perfect solution for convenient and efficient travel within the city."
  },
  {
    "name": "Pune Sedan Taxi for Airport Drop",
    "description": "Enjoy reliable and timely sedan taxi services for airport drops in Pune. Our service is ideal for travelers heading to Pune Airport or looking for pickups from home, office, or hotel. We ensure punctuality, courteous chauffeurs, and clean sedans like Dzire and Etios—offering smooth airport transfers without the stress of last-minute delays or high fares."
  },
  {
    "name": "Dzire Sedan Taxi Pune",
    "description": "Book Swift Dzire sedan taxis in Pune for affordable yet comfortable travel. The Dzire is a perfect choice for small families and professionals who seek a reliable and economical mode of transport for both local and outstation travel. Spacious seating, smooth suspension, and air-conditioning make every ride a breeze."
  },
  {
    "name": "Etios Sedan Cabs in Pune",
    "description": "Hire Toyota Etios sedan cabs in Pune for a stylish and comfortable ride. Known for its spacious interiors and superior ride quality, the Etios is ideal for business meetings, airport transfers, and long drives. Our fleet is well-maintained, and drivers are trained to provide a professional and customer-friendly experience."
  },
  {
    "name": "Sedan Car for Outstation Pune",
    "description": "Rent a sedan car in Pune for your outstation travel and enjoy a comfortable journey across cities. With ample boot space and comfortable seating, our sedans like Dzire and Etios are ideal for 2-4 passengers. We offer one-way, round-trip, and multi-day rentals with experienced drivers who ensure your safety and convenience throughout the trip."
  },
  {
    "name": "Sedan Cab Booking Hinjewadi",
    "description": "Book sedan cabs in Hinjewadi, Pune for daily office commutes, client meetings, or weekend plans. Whether you live or work in Hinjewadi, our reliable cab service offers prompt pickup, air-conditioned vehicles, and professional drivers. Our affordable pricing and 24/7 availability make us a preferred choice in the IT hub of Pune."
  },
  {
    "name": "Pune to Mumbai Sedan Cab",
    "description": "Travel from Pune to Mumbai in a comfortable and affordable sedan cab. Our service ensures a smooth intercity journey with well-maintained vehicles, courteous drivers, and transparent pricing. Ideal for solo travelers, couples, or small families, the sedan cab is a cost-effective and relaxing alternative to buses or trains for this popular route."
  },
  {
    "name": "Sedan Taxi for Marriage Pune",
    "description": "Book sedan taxis in Pune for wedding events and guest transportation. Whether it’s ferrying guests between venues, hotel pickups, or airport transfers for family members, our clean and air-conditioned sedans provide elegant and reliable transport for your special day. Flexible booking packages and trained chauffeurs ensure your event runs smoothly."
  },
  {
    "name": "Sedan for Pune to Mahabaleshwar",
    "description": "Hire a comfortable sedan for your Pune to Mahabaleshwar trip and enjoy a scenic journey to the hills. Sedans like Dzire and Etios provide the perfect blend of affordability and comfort, making them ideal for couples or small families seeking a relaxed getaway from city life."
  },
  {
    "name": "Sedan Cars for Rent in Pune",
    "description": "Rent sedan cars in Pune for daily or long-term use. Choose from a range of models suitable for personal, corporate, or leisure travel. Our vehicles are clean, well-serviced, and come with experienced chauffeurs who ensure a pleasant ride experience across Pune and beyond."
  },
  {
    "name": "Sedan Cabs for Pune to Goa",
    "description": "Plan your Pune to Goa trip with our comfortable sedan cab service. With professional drivers, clean vehicles, and competitive fares, your long journey turns into a relaxing drive. Ideal for small groups, our sedans make beach vacations, workcations, or festive getaways smoother and more enjoyable."
  },
  {
    "name": "Affordable Sedan Cab Pune",
    "description": "Looking for an affordable taxi in Pune? Our sedan cab services offer budget-friendly rides without compromising on safety or comfort. With transparent pricing, punctual service, and courteous drivers, we are a trusted name for local and intercity travel at economical rates."
  },
  {
    "name": "Premium Sedan Taxi Pune",
    "description": "Upgrade your travel experience with premium sedan taxis in Pune. Enjoy the luxury of plush seating, professional drivers, and a superior ride experience. Perfect for corporate transfers, airport pickups, and special occasions where style and comfort matter."
  },
  {
    "name": "Book Sedan Cab Viman Nagar",
    "description": "Book a reliable sedan cab in Viman Nagar, Pune for local commutes, airport transfers, or outstation travel. Fast booking, well-maintained vehicles, and affordable rates make us the go-to choice for residents and professionals in this prime area."
  }
],
"tableData": [
  ["Sedan Car Hire Pune", "Sedan Cabs for Local Travel Pune"],
  ["Pune Sedan Taxi for Airport Drop", "Dzire Sedan Taxi Pune"],
  ["Etios Sedan Cabs in Pune", "Sedan Car for Outstation Pune"],
  ["Sedan Cab Booking Hinjewadi", "Pune to Mumbai Sedan Cab"],
  ["Sedan Taxi for Marriage Pune", "Sedan for Pune to Mahabaleshwar"],
  ["Sedan Cars for Rent in Pune", "Sedan Cabs for Pune to Goa"],
  ["Affordable Sedan Cab Pune", "Premium Sedan Taxi Pune"],
  ["Book Sedan Cab Viman Nagar"]
],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Affordable Sedan Cabs in Pune",
    "WhyChoosedescription": "Prince Cabs offers a premium range of well-maintained sedan cabs in Pune, ideal for city rides, airport transfers, and long-distance travel. Our sedans, such as Swift Dzire, Honda Amaze, and Hyundai Aura, are known for their smooth drive, comfort, and fuel efficiency—making them the perfect choice for solo travelers, couples, or small families who value comfort without overspending."
  },
  {
    "WhyChooseheading": "Competitive Rates with Transparent Pricing",
    "WhyChoosedescription": "Our sedan cab booking services in Pune come with highly competitive pricing and no hidden charges. The fare includes fuel, tolls, driver allowance, and taxes. Whether it’s a short ride or a full-day rental, our clear and upfront pricing model ensures complete transparency, so you always know what you're paying for, with no surprises at the end of your trip."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Every Need",
    "WhyChoosedescription": "We offer flexible booking options including one-way rides, round trips, local hourly rentals, and outstation journeys. You can easily book a sedan cab in Pune through phone, WhatsApp, or our online portal. Our system provides real-time booking confirmation, easy rescheduling, and flexible cancellation policies, giving you complete control over your travel plans."
  },
  {
    "WhyChooseheading": "Professionally Trained and Courteous Drivers",
    "WhyChoosedescription": "All our drivers are professionally trained, experienced, and background-verified. They are well-versed with Pune city routes and traffic patterns, ensuring that you reach your destination on time and without hassle. Courteous and customer-friendly, our drivers enhance your overall travel experience with their professional attitude and safe driving."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Sedans",
    "WhyChoosedescription": "Our fleet of sedan cabs is regularly serviced and sanitized before every ride to ensure maximum comfort and hygiene. Each vehicle is equipped with air conditioning, clean seat covers, and safety features like seat belts and airbags. We strictly follow hygiene protocols to give you a clean, safe, and pleasant ride experience."
  },
  {
    "WhyChooseheading": "Ideal for Business and Daily Travel",
    "WhyChoosedescription": "Sedan cabs are a popular choice for business professionals, daily commuters, and travelers who prefer a more refined travel experience. Whether you're attending meetings, heading to the airport, or going on a weekend trip, our sedan cab service offers a perfect mix of comfort, reliability, and affordability."
  },
  {
    "WhyChooseheading": "24/7 Availability and Customer Support",
    "WhyChoosedescription": "Prince Cabs offers 24/7 sedan cab availability across Pune along with round-the-clock customer support. Whether you have a late-night flight or an early morning meeting, our team is here to help with bookings, changes, or any assistance you need—making your sedan cab booking experience seamless and stress-free."
  }
]























    }

const faqData = [
    {
        question: 'Can I book a sedan cab in Pune with Prince Cabs?',
        answer: 'Yes, Prince Cabs offers easy and reliable sedan cab bookings in Pune, ideal for local travel, airport transfers, and outstation trips.',
    },
    {
        question: 'What sedan car options are available with Prince Cabs?',
        answer: 'We offer popular sedan models like Swift Dzire, Honda Amaze, and Hyundai Xcent for a smooth and comfortable ride.',
    },
    {
        question: 'Are sedan cabs suitable for long-distance travel from Pune?',
        answer: 'Absolutely! Our sedan cabs are perfect for both local and long-distance travel, providing a balance of comfort and affordability.',
    },
    {
        question: 'Are Prince Cabs’ sedan vehicles clean and well-maintained?',
        answer: 'Yes, all sedan cabs are regularly serviced, cleaned, and sanitized to ensure a safe and pleasant travel experience.',
    },
    {
        question: 'Can I hire a sedan cab with a driver in Pune?',
        answer: 'Yes, all our sedan bookings include a professional and experienced driver for your convenience.',
    },
    {
        question: 'What are the charges for booking a sedan cab in Pune?',
        answer: 'Sedan cab fares depend on the distance and duration of your trip. Contact Prince Cabs for the best rates.',
    },
    {
        question: 'How do I book a sedan cab in Pune?',
        answer: 'You can easily book through our website or by calling our customer support team for instant confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Vinay Joshi",
        position: "Corporate Client",
        text: "I regularly book sedan cabs with Prince Cabs in Pune for office travel. The cars are clean, on time, and the drivers are very professional.",
        image: "/img/testimonial/testimonial-thumb-sedan-pune-1.png",
    },
    {
        name: "Ms. Pooja Rane",
        position: "Daily Commuter",
        text: "Prince Cabs' sedan service in Pune is reliable and affordable. Highly recommended for comfortable daily travel.",
        image: "/img/testimonial/testimonial-thumb-sedan-pune-2.png",
    },
];






































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Sedan Cabs Booking in Pune",
  "description": "Book sedan cabs in Pune for airport transfers, outstation trips, local travel, weddings, and city tours. Choose from Dzire, Etios, and premium sedan options. Available in Hinjewadi, Viman Nagar, and all major locations.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Sedan Car Hire Pune",
    "Sedan Cabs for Local Travel Pune",
    "Pune Sedan Taxi for Airport Drop",
    "Dzire Sedan Taxi Pune",
    "Etios Sedan Cabs in Pune",
    "Sedan Car for Outstation Pune",
    "Sedan Cab Booking Hinjewadi",
    "Pune to Mumbai Sedan Cab",
    "Sedan Taxi for Marriage Pune",
    "Sedan for Pune to Mahabaleshwar",
    "Sedan Cars for Rent in Pune",
    "Sedan Cabs for Pune to Goa",
    "Affordable Sedan Cab Pune",
    "Premium Sedan Taxi Pune",
    "Book Sedan Cab Viman Nagar"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};




    return (
        <div>

<Helmet>
  <title>Sedan Cabs Booking in Pune | Dzire & Etios for Outstation & Local Travel</title>
  <meta
    name="description"
    content="Book sedan cabs in Pune including Dzire and Etios for outstation travel, airport drop, and local rides. Affordable and premium options available in Hinjewadi, Viman Nagar & more."
  />
  <meta
    name="keywords"
    content="Sedan Car Hire Pune, Sedan Cabs for Local Travel Pune, Pune Sedan Taxi for Airport Drop, Dzire Sedan Taxi Pune, Etios Sedan Cabs in Pune, Sedan Car for Outstation Pune, Sedan Cab Booking Hinjewadi, Pune to Mumbai Sedan Cab, Sedan Taxi for Marriage Pune, Sedan for Pune to Mahabaleshwar, Sedan Cars for Rent in Pune, Sedan Cabs for Pune to Goa, Affordable Sedan Cab Pune, Premium Sedan Taxi Pune, Book Sedan Cab Viman Nagar"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/60.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Sedancabsbookinginpune ;